import React from 'react'; 
import PropTypes from 'prop-types';
import RadioSection from '../../../Sections/RadioSection';

export default class IsOwner extends React.Component {
    render() {
        const p = this.props;
        let title = p.lookup.title + p.address1 + '?';
        if (p.isTwoMeter)
            title = p.lookup.title + p.address1 + ' and ' + p.address2 + '?';
        return (
            <div>
                <RadioSection name={p.name} title={title} items={p.lookup.items} required />
            </div>
        );
    }
}

IsOwner.propTypes = {
    name: PropTypes.string.isRequired,
    address1: PropTypes.string,
    address2: PropTypes.string,
    isTwoMeter: PropTypes.bool,
};

export function IsOwnerValidation(name) {
    return [[name, p => p.isOwner != null]];
}